import { lazy } from 'react'

const HistoricoPage = lazy(() =>
  import('../pages').then((module) => ({ default: module.HistoricoSimulacaoPropostaPage })),
)

export const brasilHistoricoRoutes = [
  {
    path: 'historico/simulacoes',
    element: <HistoricoPage />,
  },
  {
    path: 'historico/propostas',
    element: <HistoricoPage />,
  },
]
